module.exports = __webpack_public_path__ + "static/media/check.743e2c6d.svg";